const BUSINESS_TYPES = [
  {
    label: "Marchand agricole / Magasin de ferme",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Refuge pour animaux / Organisme de bienfaisance",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Parc d'engraissement de fond",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Producteur de bœuf",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Poulets de chair", value: "Broilers", id: "broilers" },
  {
    label: "Groupe d'achat",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Production de veaux",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Ranch de veaux / Développeur",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Acheteur de bétail", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Éleveur sous contrat",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Coopérative", value: "Cooperative", id: "cooperative" },
  {
    label: "Siège social",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Exploitation vache-veau",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Production laitière",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributeur / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Moulin à aliments", value: "Feed Mill", id: "feed_mill" },
  { label: "Parc d'engraissement", value: "Feedyard", id: "feedyard" },
  {
    label: "Éleveur/Parc d'élevage",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Couvoirs", value: "Hatchery", id: "hatchery" },
  {
    label: "Production de génisses",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Intégration de poules pondeuses",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Poules pondeuses", value: "Layers", id: "layers" },
  { label: "Médias", value: "Media", id: "media" },
  {
    label: "Coopérative laitière/Acheteur",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Producteur mixte/Autre",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Fournisseur de nutriments",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Conditionneur/Transformateur",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Point de vente d'animaux de compagnie",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacie", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Éleveur de volailles",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Intégrateur de volailles",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Producteur ovin", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Exploitation de stockage",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Parc à bestiaux/Salle des ventes",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Producteur porcin", value: "Swine Producer", id: "swine_producer" },
  { label: "Dindes", value: "Turkeys", id: "turkeys" },
  {
    label: "Université / Éducation",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Cabinet vétérinaire",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Grossiste / Détaillant",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Acheteur de laine", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obligatoire",
    },
  },
  salutation: {
    label: "Civilité",
    placeholder: "Sélectionnez une civilité",
    errors: {
      required: "La civilité est obligatoire",
      invalid: "Veuillez sélectionner une civilité valide",
    },
  },
  firstName: {
    label: "Prénom",
    placeholder: "Jean",
    errors: {
      authenticatedNameUpdateTrial:
        "Vous êtes connecté et votre nom ne peut pas être modifié.",
      required: "Le prénom est obligatoire",
      minLength: "Le prénom doit contenir au moins 2 caractères",
      maxLength: "Le prénom ne peut pas dépasser 50 caractères",
    },
  },
  lastName: {
    label: "Nom de famille",
    placeholder: "Dupont",
    errors: {
      authenticatedNameUpdateTrial:
        "Vous êtes connecté et votre nom ne peut pas être modifié.",
      required: "Le nom de famille est obligatoire",
      minLength: "Le nom de famille doit contenir au moins 2 caractères",
      maxLength: "Le nom de famille ne peut pas dépasser 50 caractères",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "jean.dupont@exemple.be",
    description:
      "Veuillez saisir une adresse e-mail personnelle, pas une adresse partagée.",
    prefixWarningTitle: "Boîte mail partagée détectée",
    prefixWarningDescription:
      "Nous recommandons d'utiliser une adresse e-mail personnelle pour une expérience personnalisée optimale",
    errors: {
      authenticatedEmailUpdateTrial:
        "Vous êtes connecté et votre adresse e-mail ne peut pas être modifiée.",
      required: "L'e-mail est obligatoire",
      invalidEmail: "Veuillez saisir une adresse e-mail valide",
      emailAssociatedWithYourAccount:
        "Votre adresse e-mail est associée à votre compte et ne peut pas être modifiée.",
    },
  },
  confirmEmail: {
    label: "Confirmer l'e-mail",
    placeholder: "jean.dupont@exemple.be",
    errors: {
      authenticatedEmailUpdateTrial:
        "Vous êtes connecté et votre adresse e-mail ne peut pas être modifiée.",
      required: "La confirmation de l'e-mail est obligatoire",
      invalidEmail: "Veuillez saisir une adresse e-mail valide",
      emailMatchError: "Les adresses e-mail ne correspondent pas",
    },
  },
  password: {
    label: "Mot de passe",
    placeholder: "Saisissez votre mot de passe",
    errors: {
      required: "Le mot de passe est obligatoire",
    },
  },
  confirmPassword: {
    label: "Confirmer le mot de passe",
    placeholder: "Confirmez votre mot de passe",
    errors: {
      required: "La confirmation du mot de passe est obligatoire",
      passwordMatchError: "Les mots de passe ne correspondent pas",
    },
  },
  addressLine1: {
    label: "Adresse ligne 1",
    placeholder: "123 Rue Principale",
    errors: {
      required: "L'adresse ligne 1 est obligatoire",
      minLength: "L'adresse ligne 1 doit contenir au moins 5 caractères",
      maxLength: "L'adresse ligne 1 ne peut pas dépasser 100 caractères",
    },
  },
  addressLine2: {
    label: "Adresse ligne 2",
    placeholder: "Appt 4B",
    errors: {
      required: "L'adresse ligne 2 est obligatoire",
      maxLength: "L'adresse ligne 2 ne peut pas dépasser 100 caractères",
    },
  },
  city: {
    label: "Ville / Commune",
    placeholder: "Bruxelles",
    errors: {
      required: "La ville / commune est obligatoire",
      minLength: "La ville / commune doit contenir au moins 2 caractères",
      maxLength: "La ville / commune ne peut pas dépasser 50 caractères",
    },
  },
  country: {
    label: "Pays",
    placeholder: "Sélectionner un pays",
    errors: {
      required: "Le pays est requis",
      invalid: "Veuillez sélectionner un pays valide",
    },
  },
  state: {
    label: "Province",
    placeholder: "Sélectionnez une province",
    errors: {
      required: "La province est obligatoire",
      invalid: "Veuillez sélectionner une province valide",
    },
  },
  jurisdiction: {
    label: "Juridiction de la licence",
    placeholder: "Sélectionnez la juridiction de la licence",
    errors: {
      required: "La juridiction de la licence est obligatoire",
      invalid: "Veuillez sélectionner une juridiction valide",
    },
  },
  zipCode: {
    label: "Code postal",
    placeholder: "1000",
    errors: {
      required: "Le code postal est obligatoire",
      invalid: "Veuillez saisir un code postal valide",
    },
  },
  role: {
    label: "Rôle",
    placeholder: "Sélectionnez votre rôle",
    errors: {
      required: "Veuillez sélectionner votre rôle",
      invalid: "Veuillez sélectionner un rôle valide",
    },
  },
  businessType: {
    label: "Type d'entreprise",
    placeholder: "Sélectionnez le type d'entreprise",
    errors: {
      required: "Le type d'entreprise est obligatoire",
      invalid: "Veuillez sélectionner un type d'entreprise valide",
    },
  },
  businessName: {
    label: "Nom de l'entreprise",
    placeholder: "Saisissez le nom de l'entreprise",
    errors: {
      required: "Le nom de l'entreprise est obligatoire",
      minLength: "Le nom de l'entreprise doit contenir au moins 2 caractères",
      maxLength: "Le nom de l'entreprise ne peut pas dépasser 100 caractères",
    },
  },
  businessSearch: {
    label: "Recherche d'entreprise :",
    addNewAccount: "Ajouter un nouveau compte d'entreprise",
    canNotFindBusiness: "Vous ne trouvez pas votre entreprise ?",
    guideline:
      "Veuillez saisir votre code postal, puis sélectionner dans la liste ci-dessous.",
    guidelineForNameSearch:
      "Veuillez saisir le nom complet de l'entreprise, puis sélectionner dans la liste.",
    placeholder: "Où travaillez-vous ?",
    noResults: "Aucun résultat trouvé",
    searching: "Recherche en cours...",
    selectedBusinessHeading: "Entreprise sélectionnée :",
    selectedBusinessNotCorrect: "Pas correct ?",
    selectedBusinessTryAgain: "Réessayer",
    selectedBusinessDismiss: "Ignorer l'entreprise",
    resultsFound: {
      singular: "1 entreprise trouvée",
      plural: "Plusieurs entreprises trouvées",
    },
    errors: {
      network:
        "Nous rencontrons des difficultés pour nous connecter au service de recherche d'entreprises. Veuillez réessayer plus tard.",
    },
  },
  explicitConsent: {
    label:
      "En cochant cette case, j'accepte de recevoir des communications marketing d'Elanco.",
    errors: {
      required: "Le consentement est requis",
    },
  },
  explicitSmsConsent: {
    label:
      "En cochant cette case, j'accepte de recevoir des communications marketing d'Elanco par SMS/message texte.",
    errors: {
      required: "Le consentement au SMS est requis",
    },
  },
  telephone: {
    label: "Téléphone personnel",
    placeholder: "Saisissez votre téléphone personnel",
    dialCodeLabel: "Code",
    dialCodePlaceholder: "Rechercher un pays…",
    errors: {
      invalid: "Veuillez saisir un numéro de téléphone valide.",
    },
  },
  businessTelephone: {
    label: "Téléphone professionnel",
    placeholder: "Saisissez votre téléphone professionnel",
    dialCodeLabel: "Code",
    dialCodePlaceholder: "Rechercher un pays…",
    errors: {
      invalid: "Veuillez saisir un numéro de téléphone valide.",
    },
  },
  professionalNumber: {
    label: "Numéro professionnel",
    placeholder: "1234567",
    errors: {
      required: "Veuillez saisir un numéro professionnel",
      maxLength: "La saisie dépasse la limite de caractères",
    },
  },
  addressSearch: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  businessSearchField: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  checkbox: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  combobox: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  datePicker: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  dateRange: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  dateTime: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  emailField: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  fileInput: {
    errors: {
      required: "Veuillez sélectionner un fichier",
    },
  },
  number: {
    errors: {
      required: "Veuillez saisir un nombre",
      minValue: "Veuillez saisir une valeur supérieure au minimum",
      maxValue: "Veuillez saisir une valeur inférieure au maximum",
    },
  },
  passwordField: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  rangeSlider: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  select: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  telephoneField: {
    errors: {
      required: "Veuillez saisir uniquement des chiffres",
      invalidTelephone: "Veuillez saisir un numéro de téléphone valide",
      invalidFormat: "Format de numéro invalide",
    },
  },
  text: {
    errors: {
      required:
        "Veuillez utiliser uniquement des lettres (A-Z), des chiffres (0-9) et aucun symbole",
      maxLength: "La saisie dépasse la limite de caractères",
      minLength: "La saisie doit contenir au moins 2 caractères",
    },
  },
  textarea: {
    characters: "caractères",
  },
  time: {
    errors: {
      required: "Ce champ est obligatoire",
    },
  },
  form: {
    errors: {
      generic:
        "Une erreur s'est produite lors de la soumission de votre formulaire. Veuillez réessayer.",
      reportAnIssue: "Veuillez signaler un problème.",
      configuration: "Erreur de configuration",
      noFormQuestionsAvailable: "Aucune question de formulaire disponible.",
      formComponentLoad:
        "Le composant de formulaire n'a pas pu être chargé en raison d'un champ non pris en charge.",
      code: "Code",
      type: "Type",
      missingRequiredFields:
        "Ce formulaire manque de champs obligatoires (e-mail et/ou consentement). Veuillez contacter un administrateur pour corriger la configurationdu formulaire.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Universitaire", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Bien-être animal - Autre",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Bien-être animal - Personnel de vente",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Bien-être animal - Vétérinaire",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Bien-être animal - Infirmier vétérinaire",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Bien-être animal - Bénévole",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Extension bovins / parc d'engraissement",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Producteur de bœuf",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Éleveur", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Administrateur d'entreprise / Réceptionniste",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Propriétaire d'entreprise / Associé",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Nutritionniste consultant",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Employé vétérinaire d'entreprise (hors hôpital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Producteur laitier",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributeur", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Représentant distributeur, sur le terrain",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Représentant distributeur, interne",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Institut d'enseignement - Élève du secondaire",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Institut d'enseignement - Étudiant TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Institut d'enseignement - Étudiant universitaire",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Toiletteur", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Directeur médical/clinique",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Vente d'aliments",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Professionnel de la nutrition",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionniste", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Gestionnaire de cabinet/pratique",
    id: "office_practice_manager",
  },
  {
    value: "OTC Retailer",
    label: "Détaillant en vente libre",
    id: "otc_retailer",
  },
  { value: "Pharmacist", label: "Pharmacien", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacie - Personnel",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Producteur porcin", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Producteur avicole",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Propriétaire de cabinet, non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Réceptionniste/Service client",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Magasin revendeur - Personnel",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Producteur - Mixte/Autre",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Détaillant",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Éleveur de moutons",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Étudiant RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Vétérinaire",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Formateur", id: "trainer" },
  { value: "Veterinarian", label: "Vétérinaire", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Vétérinaire, propriétaire de cabinet",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Assistant vétérinaire",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Infirmier vétérinaire",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Cabinet vétérinaire - Autre",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Cabinet vétérinaire - Vétérinaire",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Cabinet vétérinaire - Infirmier vétérinaire",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Spécialiste vétérinaire",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Étudiant vétérinaire",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Chirurgien vétérinaire",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Technicien vétérinaire",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Grossiste", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Mlle",
    value: "Miss",
    id: "miss",
  },
  {
    label: "M.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Mme",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Mme",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professeur",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
